<template>
    <div class="file-upload">
        <div v-for="(doc, itemIndex) in documents" style="border-bottom: 1px dotted #dfdfdf; margin-bottom: 5px; padding-bottom: 2px;">
            <div class="flex" v-if="documents[itemIndex]['editing'] === false">
                <a class="text-muted" href="#"  @click.prevent.stop="deleteLine(doc.id)">[remove]</a>
                <a class="text-muted" href="#"
                   @click.prevent.stop="()=>documents[itemIndex]['editing'] = true">[rename]</a>
            </div>
            <div class="input-group mb-3" v-if="documents[itemIndex]['editing'] === true">
                <input type="text" class="form-control" v-model="doc.file_name">
                <div class="input-group-append">
                    <span class="input-group-text btn-rename" id="basic-addon1"
                          @click="saveItem(doc, itemIndex)">Save</span>
                </div>
            </div>
            <a v-else :id="'doc'+doc.id" style="display: block" target="_blank" :href="'/'+doc.path">
                <span>{{ doc.file_name }}</span>
            </a>
        </div>

        <input v-for="i in n" type="file" :name="`inspections_documents[${itemId}-${siteId}][]`"/>
        <span @click="n++" class="fa fa-plus"></span>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    props: {
        itemId: {},
        siteId: {}
    },
    data() {
        return {
            n: 1,
            documents: [],
        };
    },
    mounted() {
        this.getDocuments()
    },
    methods: {
        deleteLine(id) {
            let app = this;
            axios.delete('/documents/' + id)
                .then((response) => {
                    $('#doc' + id).remove()
                })
                .catch(error => {
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })

        },
        saveItem(item, index) {
            let app = this
            axios.put(`/documents/${item.id}`, item)
                .then((response) => {
                })
                .catch(error => {
                    app.documents[index].editing = false;
                    if (error.response.status === 500) {
                        showMessage('e', 'Could not complete request');
                    }

                    if (error.response.status === 401) {
                        showMessage('w', error.response.data.server_error);
                    }

                    if (error.response.status === 405) {
                        showMessage('w', 'Upload URL is not valid');
                    }

                    if (error.response.status === 400) {
                        this.errors = error.response.data.errors || {};
                        showMessage('w', 'Fill in all mandatory fields');
                    }
                })
                .finally(() => {
                    app.getDocuments()
                })
        },
        async getDocuments() {
            let result = await axios.get('/work_orders/' + this.itemId + '/site/' + this.siteId + '/documents')
            this.documents = result.data.map((e) => {
                e['editing'] = false;
                return e;
            });
        }
    }
};
</script>

<style scoped>
.file-upload {
    display: flex;
    flex-direction: column;
    max-width: 300px;
}

input[type="file"] {
    margin-bottom: 10px;
}

.btn-rename {
    cursor: pointer;
    padding: 2px !important;
    font-size: .8em !important;
}

.btn-rename:hover {
    background: #9fcdff;
    border: 1px solid;
    color: #0e0b04;
}

.btn-rename:active {
    background: #6290c5;
}
</style>
